import { useTranslation } from "react-i18next";

export type MemberCounterProps = {
  memberNumber: number;
}

export const MemberCounter = (props: MemberCounterProps) => {
  const { t } = useTranslation()

  return (
    <><div className="text-gray-100 p-3">{t('totalMembers')}: {new Intl.NumberFormat('en').format(props.memberNumber)}</div></>
  )
}